import { defineComponent, createBlock, openBlock, unref, withCtx, createVNode, mergeProps, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import _sfc_main$2 from "../../button/Button.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogCancel.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogCancel",
  props: {
    onClick: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {},
    buttonType: {},
    size: {},
    loading: { type: Boolean },
    disabled: { type: Boolean },
    buttonVariant: {},
    danger: { type: Boolean },
    shape: {},
    href: {},
    target: {},
    variant: {}
  },
  setup(__props) {
    const props = __props, buttonProps = reactiveOmit(props, ["class"]);
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), {
      class: "contents",
      as: "div",
      "as-child": _ctx.asChild
    }, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$2), mergeProps(unref(buttonProps), {
          class: unref(cn)("mt-2 sm:mt-0", props.class),
          "button-type": "default",
          "button-variant": "outlined"
        }), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }, 8, ["as-child"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogCancel.js.map
